import { useState, useEffect } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Chip, Stack } from '@mui/material'
import { AxiosError } from 'axios'
import {
  Card,
  Grid,
  Input,
  Button,
  Row,
  Form,
  InputMask,
  Span
} from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import { useForm } from 'react-hook-form'
import { TalkWithUsServices } from 'services/NGT/Parameterization'
import { COLORS, SPACING, FORMAT } from 'utils'
import * as Yup from 'yup'

import ModalEditTalkWithUs from './components/ModalEditTalkWithUs/ModalEditTalkWithUs'
import { TableActions } from './components/TableActions/TableActions'

interface ITalkWithUsFields {
  email: string
  reason: string
}

export default function TalkWithUs() {
  const [tableRows, setTableRows] = useState([])
  const [, setFormatedRows] = useState([])
  const [emails, setEmails] = useState<string[]>([])
  const { setLoading, setMsgErro } = useLoading()
  const [screenState, setScreenState] = useState<'' | 'editing' | 'deleting'>()
  const [selectedItem, setSelectedItem] = useState<any>()
  const { showModal } = useModal()

  const schema = (emailsArray: string[]) => {
    return Yup.object({
      email: Yup.string()
        //.email('E-mail inválido')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
        .test(
          'test-emails-array',
          'Insira pelo menos um e-mail',
          () => emailsArray.length > 0
        ),
      reason: Yup.string().required('Digite o motivo')
    })
  }

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,

    formState: { errors }
  } = useForm<ITalkWithUsFields>({
    // mode: "onChange",
    resolver: yupResolver(schema(emails))
  })

  const getTalkWithUs = async () => {
    TalkWithUsServices()
      .getParamFaleConosco()
      .then(({ data: { items } }) => {
        setLoading('idle')
        setScreenState('')
        const formatedItems = []
        items.map((item) => {
          if (item.emails.length <= 1) {
            formatedItems.push({
              dsEmail: item.emails[0]?.dsEmail || '',
              dsMotivo: item.dsMotivo,
              idParamFaleConosco: item.idParamFaleConosco
            })
            return
          }
          item.emails.map((e) =>
            formatedItems.push({
              dsEmail: e.dsEmail,
              dsMotivo: item.dsMotivo,
              idParamFaleConosco: item.idParamFaleConosco
            })
          )
        })
        setFormatedRows(formatedItems)
        setTableRows(items)
      })
  }

  const handleAddTalkWithUs = ({ reason }) => {
    setLoading('loading')

    const body = {
      dsMotivo: reason,
      emails: emails.map((email) => ({ dsEmail: email }))
    }

    TalkWithUsServices()
      .createParamFaleConosco(body)
      .then(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Inserido com sucesso',
          titleModal: 'E-mails cadastrados',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
        getTalkWithUs()
      })
      .catch((error) => {
        // setLoading('error')
        // setMsgErro('Erro ao salvar o item, tente novamente.')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao editar item, tente novamente.',
          type: 'error'
        })
      })
      .finally(() => {
        handleInputClear()
      })
  }

  const handleAddEmail = (e) => {
    trigger('email').then(() => {
      if (!emails.find((email) => Object.is(email, e.target.value))) {
        if (Object.is(e.key, 'Enter')) {
          e.preventDefault()

          if (errors?.email?.type === 'email' || !e.target.value) {
            return
          }

          setEmails([...emails, e.target.value])
          setValue('email', '')
          clearErrors('email')
        }
      } else {
        if (Object.is(e.key, 'Enter')) {
          e.preventDefault()
        }
        showModal({
          hideButtonCancel: true,
          message: `O e-mail ${e.target.value} já foi adicionado.`,
          titleModal: 'E-mail já cadastrado',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })

        setValue('email', '')
      }
    })
  }

  const handleDeleteTalkWithUs = () => {
    setLoading('loading')
    const { idParamFaleConosco } = selectedItem

    TalkWithUsServices()
      .deleteParamFaleConosco(idParamFaleConosco)
      .then(() => {
        getTalkWithUs()
        showModal({
          hideButtonCancel: true,
          message: 'Excluído com sucesso',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch((error) => {
        setLoading('idle')
        const axiosError = error as AxiosError

        if (axiosError.response.status === 400) {
          showModal({
            hideButtonCancel: true,
            message:
              axiosError.response.data.mensagem ||
              'Erro ao excluir item, tente novamente.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          return
        }

        // setMsgErro('Erro ao excluir item, tente novamente.')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao excluir item, tente novamente.',
          type: 'error'
        })
      })
  }

  const handleDeleteEmail = (index: number) => {
    const emailsCopy = [...emails]
    emailsCopy.splice(index, 1)
    setEmails(emailsCopy)
  }

  const handleInputClear = () => {
    setValue('email', '')
    setValue('reason', '')
    setEmails([])
    clearErrors()
  }

  const handleScreenChange = (row, screen) => {
    setSelectedItem(row)
    setScreenState(screen)
  }

  const handleEditTalkWithUs = (data) => {
    setLoading('loading')

    const { idParamFaleConosco } = selectedItem
    const formatedEmailsData = data.email?.map((item) => {
      return item.dsEmail
    })
    const editedItem = {
      dsMotivo: data.reason,
      emails: formatedEmailsData,
      idParamFaleConosco
    }
    TalkWithUsServices()
      .editParamFaleConosco(editedItem)
      .then(() => {
        getTalkWithUs()
        showModal({
          hideButtonCancel: true,
          message: 'Atualizado com sucesso',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch((error) => {
        // setLoading('error')
        // setMsgErro('Erro ao editar item, tente novamente.')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao editar item, tente novamente.',
          type: 'error'
        })
      })
  }

  useEffect(() => {
    setLoading('loading')
    getTalkWithUs()
  }, [])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Form onSubmit={handleSubmit((data) => handleAddTalkWithUs(data))}>
          <Grid
            gridCols="2fr 7fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <InputMask
              type="alfanumeric"
              formValue="reason"
              label="Motivo"
              placeholder="Informe o Motivo"
              control={control}
              errors={errors}
              maxLength={50}
            />
          </Grid>

          <Grid
            gridCols="2fr 7fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing10} 0`}
          >
            <InputMask
              label="E-mail Destinatário (Grupos)"
              placeholder="Informe os Emails"
              formValue="email"
              type={'email'}
              onKeyPress={handleAddEmail}
              control={control}
              errors={errors}
              required
            />
          </Grid>
          <Row marginBottom={SPACING.spacing30}>
            <Span
              color={COLORS.darkGray}
              text="Pressione Enter para inserir um E-mail"
            />
          </Row>
          <Grid
            gridCols="2fr 7fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Stack direction="row" spacing={1}>
              {emails.map((email, index) => (
                <Chip
                  key={String(index)}
                  label={email}
                  variant="outlined"
                  onDelete={() => handleDeleteEmail(index)}
                />
              ))}
            </Stack>
          </Grid>

          <Row marginBottom={SPACING.spacing30} justifyContent="flex-end">
            <Button
              text="Limpar"
              variantButton="text"
              onClick={handleInputClear}
            />
            <Button text="Salvar" variantButton="default" type="submit" />
          </Row>
        </Form>

        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing10}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <TableActions
            rows={FORMAT.orderByLast(tableRows)}
            onDelete={(item) => handleScreenChange(item, 'deleting')}
            onEdit={(item) => handleScreenChange(item, 'editing')}
          />
        </Grid>
      </Card>
      {screenState === 'deleting' && (
        <SuccessModal
          open={screenState === 'deleting'}
          message={`Tem certeza que deseja deletar "${selectedItem.dsMotivo}"?`}
          type="alert"
          txtButtonCancel="NÃO"
          txtButtonConfirm="SIM"
          handleCancel={() => setScreenState('')}
          handleConfirm={() => {
            setScreenState('')
            handleDeleteTalkWithUs()
          }}
        />
      )}
      {screenState === 'editing' && (
        <ModalEditTalkWithUs
          isOpen={screenState === 'editing'}
          onClose={() => setScreenState('')}
          handleEdit={handleEditTalkWithUs}
          formValue={selectedItem}
          title="Editar Fale Conosco"
        />
      )}
    </>
  )
}
